// Payroll Mutations

export const updatePayrollList = (state, payload) => {
  state.payrollList = payload
}

export const fetchPayrollInfo = (state, payload) => {
  state.payrollInfo = payload
}
